import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import MarketTabs from '../MarketTabs';
import HeroListTab from './Components/HeroListTab';
import { MarketPlaceTab } from '../MarketTabs/configs';
import CosmeticListTab from './Components/CosmeticListTab';

const RecentlyTraded = ({
  className
}) => {
  const [currentTab, setCurrentTab] = React.useState(MarketPlaceTab.HEROES);

  const renderTab = () => {
    switch (currentTab) {
      case MarketPlaceTab.COSMETICS:
        return /*#__PURE__*/React.createElement(CosmeticListTab, null);

      default:
        return /*#__PURE__*/React.createElement(HeroListTab, null);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "RECENTLY TRADED"), /*#__PURE__*/React.createElement(MarketTabs, {
    onTabChanged: setCurrentTab,
    currentTab: currentTab,
    className: styles.tabs
  }), renderTab());
};

export default RecentlyTraded;